/**
 * Notifications container
 */
import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService, ToastContainerDirective } from 'ngx-toastr';

@Component({
    selector: 'dm-notifications',
    templateUrl: 'notifications.container.html',
})
export class NotificationsContainerComponent implements OnInit {
    @ViewChild(ToastContainerDirective, { static: true }) toastContainer: ToastContainerDirective;

    constructor(private readonly toastrService: ToastrService) { }

    ngOnInit() {
        this.toastrService.overlayContainer = this.toastContainer;
    }
}
